// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testInstanceId } from './TestInstance';
import { attributeChangeSource } from './AttributeChangeSource';
import { operatorId } from './Operator';
import { testTemplateRevisionId } from './TestTemplateRevision';
import { z } from 'zod';
export const testAttributeChangeGroupId = (z.string());
export const testAttributeChangeGroup = z.object({
    id: testAttributeChangeGroupId,
    test_instance_id: testInstanceId,
    source: attributeChangeSource,
    operator_id: operatorId.nullable(),
    label: z.string().nullable(),
    test_template_revision_id: testTemplateRevisionId.nullable(),
    from_revision_id: testTemplateRevisionId.nullable(),
    source_ref: z.string().nullable(),
    opened_at: z.date(),
    closed_at: z.date().nullable(),
});
export const testAttributeChangeGroupInitializer = z.object({
    id: testAttributeChangeGroupId.optional(),
    test_instance_id: testInstanceId,
    source: attributeChangeSource,
    operator_id: operatorId.optional().nullable(),
    label: z.string().optional().nullable(),
    test_template_revision_id: testTemplateRevisionId.optional().nullable(),
    from_revision_id: testTemplateRevisionId.optional().nullable(),
    source_ref: z.string().optional().nullable(),
    opened_at: z.date().optional(),
    closed_at: z.date().optional().nullable(),
});
export const testAttributeChangeGroupMutator = z.object({
    id: testAttributeChangeGroupId.optional(),
    test_instance_id: testInstanceId.optional(),
    source: attributeChangeSource.optional(),
    operator_id: operatorId.optional().nullable(),
    label: z.string().optional().nullable(),
    test_template_revision_id: testTemplateRevisionId.optional().nullable(),
    from_revision_id: testTemplateRevisionId.optional().nullable(),
    source_ref: z.string().optional().nullable(),
    opened_at: z.date().optional(),
    closed_at: z.date().optional().nullable(),
});
//# sourceMappingURL=TestAttributeChangeGroup.js.map